import AuthService from "../../api/services/auth";
import UserService from "../../api/services/user";

export default {
  namespaced: true,
  state: {
    currentUser: {},
    signedIn: false,
    csrf: null,
  },

  getters: {
    isInsurerManager: (state) => state.currentUser.profileType?.toLowerCase() === "insurermanager",
    isInsurerAdmin: (state) => state.currentUser.role === "admin",
  },

  mutations: {
    setCurrentUser(state, { currentUser, csrf }) {
      state.currentUser = currentUser;
      state.signedIn = true;
      state.csrf = csrf;
    },

    unsetCurrentUser(state) {
      state.currentUser = {};
      state.signedIn = false;
      state.csrf = null;
    },

    refresh(state, csrf) {
      state.csrf = csrf;
      state.signedIn = true;
    },
  },

  actions: {
    async signin({ dispatch }, user) {
      const response = await AuthService.signin(user);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async signup({ dispatch }, params) {
      const response = await AuthService.signup(params);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async resetPassword({ dispatch }, { resetPasswordToken, payload }) {
      const response = await AuthService.resetPassword(resetPasswordToken, payload);
      if (!response?.success) return response;

      await dispatch("postSignIn", response);
      return response;
    },

    async postSignIn(context, response) {
      const csrf = response.data.csrf;
      if (csrf) {
        const userResponse = await UserService.getUser();
        const currentUser = userResponse.data;
        context.commit("setCurrentUser", { currentUser, csrf });
        context.dispatch("notifications/clearAll", null, { root: true });
      } else {
        context.commit("unsetCurrentUser");
      }
    },

    async refreshCurrentUser({ commit, state }) {
      const response = await UserService.getUser();
      if (!response?.success) return response;

      const currentUser = response.data;
      const csrf = state.csrf;
      commit("setCurrentUser", { currentUser, csrf });
      return response;
    },

    async signout({ commit }) {
      const response = await AuthService.signout();
      if (!response?.success) return response;

      commit("unsetCurrentUser");
      localStorage.removeItem("vuex_insurer");
      sessionStorage.clear();
      location.replace("/signin");
    },

    async forgotPassword(_, email) {
      return await UserService.forgotPassword(email);
    },
  },
};
